(() => {
  const ROOT_SELECTOR = '[data-egifts-same-design]';
  const ARTWORK_SELECTOR = 'svg.tee-mockup-artwork';
  const TEE_ATC_SELECTOR = '.tee-btn--atc';
  const VERSION = '8.6';

  if (window.EgiftsSameDesignV84) {
    window.EgiftsSameDesignV84.initAll();
    return;
  }

  const baseFetch = window.fetch.bind(window);
  const processedCustomizationIds = new Set();
  let cloneIndex = 0;
  let clearNotificationDecoration = () => {};

  const cartJsonUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart.js`.replace(/\/{2,}/g, '/');
  };

  const cartAddUrl = () => {
    if (window.routes?.cart_add_url) return window.routes.cart_add_url;
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/add.js`.replace(/\/{2,}/g, '/');
  };

  const storageKey = (customizationId) => `egifts-sd-artwork:${customizationId}`;

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const area = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.width * rect.height;
  };

  const hasArtwork = (svg) => Boolean(svg && svg.querySelector('image, path, text, tspan, use, foreignObject, g'));

  const findArtwork = () => {
    const all = Array.from(document.querySelectorAll(ARTWORK_SELECTOR)).filter(hasArtwork);
    if (!all.length) return null;
    const visible = all.filter(isVisible);
    const candidates = visible.length ? visible : all;
    candidates.sort((a, b) => area(b) - area(a));
    return candidates[0] || null;
  };

  const ensureViewBox = (clone, source) => {
    if (clone.getAttribute('viewBox')) return;

    try {
      const box = source.getBBox();
      if (box.width > 0 && box.height > 0) {
        clone.setAttribute('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`);
      }
    } catch (error) {}
  };

  const namespaceIds = (svg) => {
    cloneIndex += 1;
    const suffix = `-egifts-${cloneIndex}`;
    const idMap = new Map();

    svg.querySelectorAll('[id]').forEach((node) => {
      const oldId = node.id;
      if (!oldId) return;
      const newId = `${oldId}${suffix}`;
      idMap.set(oldId, newId);
      node.id = newId;
    });

    if (!idMap.size) return;

    [svg, ...svg.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes || []).forEach((attribute) => {
        const originalValue = attribute.value;
        let value = originalValue;

        idMap.forEach((newId, oldId) => {
          value = value.split(`url(#${oldId})`).join(`url(#${newId})`);

          if ((attribute.name === 'href' || attribute.name === 'xlink:href') && value === `#${oldId}`) {
            value = `#${newId}`;
          }
        });

        if (value !== originalValue) node.setAttribute(attribute.name, value);
      });
    });
  };

  const sanitizeSvg = (svg) => {
    svg.querySelectorAll('script').forEach((node) => node.remove());

    [svg, ...svg.querySelectorAll('*')].forEach((node) => {
      Array.from(node.attributes || []).forEach((attribute) => {
        if (/^on/i.test(attribute.name)) node.removeAttribute(attribute.name);
      });
    });

    return svg;
  };

  const makeClone = (source, namespace = true) => {
    const clone = sanitizeSvg(source.cloneNode(true));
    ensureViewBox(clone, source);

    if (namespace) namespaceIds(clone);

    // To jest nasz wizualny klon Live Preview, nie natywny renderer Teeinblue.
    // Zostawiamy cały SVG i jego maski, ale usuwamy identyfikatory, po których
    // Teeinblue wyszukuje własne artworky na stronie. Dzięki temu podgląd
    // „ten sam wzór” nadal aktualizuje się live, ale nie miesza się z galerią.
    clone.classList.remove('tee-mockup-artwork');
    clone.classList.add('egifts-sd-artwork-svg');
    clone.removeAttribute('id');

    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.width = '100%';
    clone.style.height = '100%';
    clone.style.display = 'block';
    clone.style.pointerEvents = 'none';

    return clone;
  };

  const serializeArtwork = (source) => {
    if (!source) return '';

    try {
      return new XMLSerializer().serializeToString(makeClone(source, false));
    } catch (error) {
      return '';
    }
  };

  const saveArtworkForCart = (customizationId) => {
    const source = findArtwork();
    if (!source || !customizationId) return;

    const serialized = serializeArtwork(source);
    if (!serialized) return;

    try {
      window.localStorage.setItem(storageKey(customizationId), serialized);
    } catch (error) {}
  };

  const renderArtwork = (root, source) => {
    root.querySelectorAll('[data-egifts-artwork-layer]').forEach((layer) => {
      layer.replaceChildren(makeClone(source, true));
    });
  };

  const setNote = (root, text = '', state = '') => {
    const note = root.querySelector('[data-egifts-note]');
    if (!note) return;

    note.classList.remove('is-success', 'is-error');

    if (!text) {
      note.textContent = '';
      note.hidden = true;
      return;
    }

    note.textContent = text;
    note.hidden = false;

    if (state === 'success') note.classList.add('is-success');
    if (state === 'error') note.classList.add('is-error');
  };

  const updateSelectionNote = (root) => {
    const count = root.querySelectorAll('[data-egifts-addon].is-selected').length;

    if (!count) {
      setNote(root);
      return;
    }

    setNote(
      root,
      count === 1
        ? 'Wybrano dodatek. Zostanie dodany razem z produktem głównym.'
        : `Wybrano ${count} dodatki. Zostaną dodane razem z produktem głównym.`
    );
  };

  const setSelected = (root, card, selected) => {
    const button = card.querySelector('[data-egifts-add]');
    if (!button) return;

    card.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.textContent = selected ? '✓' : '+';
    updateSelectionNote(root);
  };

  const handleize = (value = '') => {
    return String(value)
      .replace(/[Łł]/g, (char) => (char === 'Ł' ? 'L' : 'l'))
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'PLN';

    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2).replace('.', ',')} zł`;
    }
  };

  const getProductJsonUrl = (handle) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}products/${encodeURIComponent(handle)}.js`.replace(/\/{2,}/g, '/');
  };

  const getVariantImage = (variant, product) => {
    const featured = variant?.featured_image;

    if (typeof featured === 'string') return featured;
    if (featured?.src) return featured.src;
    if (product?.featured_image) return product.featured_image;

    return '';
  };

  let activePicker = null;

  const closeProductPicker = () => {
    if (!activePicker) return;

    activePicker.menu?.remove();
    activePicker.toggle?.setAttribute('aria-expanded', 'false');

    window.removeEventListener('resize', activePicker.close, true);
    window.removeEventListener('scroll', activePicker.close, true);
    document.removeEventListener('pointerdown', activePicker.outside, true);
    document.removeEventListener('keydown', activePicker.keydown, true);

    activePicker = null;
  };

  const applyVariant = (card, optionData) => {
    if (!card || !optionData) return;

    card.dataset.selectedVariantId = String(optionData.variantId || '');
    card.dataset.previewKey = optionData.previewKey || '';

    const label = card.querySelector('[data-egifts-product-picker-label]');
    const price = card.querySelector('[data-egifts-price]');
    const image = card.querySelector('[data-egifts-base-image]');

    if (label) label.textContent = optionData.label || '';
    if (price && optionData.price) price.textContent = `+${optionData.price}`;
    if (image && optionData.image) image.src = optionData.image;

    card.querySelectorAll('[data-egifts-product-picker-option]').forEach((sourceOption) => {
      sourceOption.classList.toggle(
        'is-current',
        String(sourceOption.dataset.variantId || '') === String(optionData.variantId || '')
      );
    });
  };

  const getSourceOptions = (card) => {
    return Array.from(card.querySelectorAll('[data-egifts-product-picker-option]')).map((option) => ({
      variantId: option.dataset.variantId || '',
      label: option.dataset.label || option.textContent.trim(),
      price: option.dataset.price || '',
      previewKey: option.dataset.previewKey || handleize(option.textContent || ''),
      image: option.dataset.image || ''
    }));
  };

  const positionPortalMenu = (toggle, menu) => {
    const rect = toggle.getBoundingClientRect();
    const gap = 4;
    const viewportPadding = 8;
    const availableBelow = window.innerHeight - rect.bottom - gap - viewportPadding;
    const availableAbove = rect.top - gap - viewportPadding;
    const preferredHeight = Math.min(280, Math.max(120, availableBelow));

    let top = rect.bottom + gap;
    let maxHeight = preferredHeight;

    if (availableBelow < 120 && availableAbove > availableBelow) {
      maxHeight = Math.min(280, Math.max(120, availableAbove));
      top = Math.max(viewportPadding, rect.top - gap - maxHeight);
    }

    menu.style.left = `${Math.max(viewportPadding, rect.left)}px`;
    menu.style.top = `${top}px`;
    menu.style.width = `${Math.max(150, rect.width)}px`;
    menu.style.maxHeight = `${maxHeight}px`;
  };

  const openProductPicker = (card, toggle) => {
    closeProductPicker();

    const sourceOptions = getSourceOptions(card);
    if (!sourceOptions.length) return;

    const menu = document.createElement('div');
    menu.className = 'egifts-sd-portal-menu';
    menu.setAttribute('role', 'listbox');

    sourceOptions.forEach((optionData) => {
      const button = document.createElement('button');
      const current =
        String(card.dataset.selectedVariantId || '') === String(optionData.variantId || '');

      button.type = 'button';
      button.className = `egifts-sd-portal-option${current ? ' is-current' : ''}`;
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', current ? 'true' : 'false');
      button.textContent = optionData.label;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        applyVariant(card, optionData);
        closeProductPicker();
      });

      menu.append(button);
    });

    document.body.append(menu);
    positionPortalMenu(toggle, menu);
    toggle.setAttribute('aria-expanded', 'true');

    const close = () => closeProductPicker();

    const outside = (event) => {
      if (event.target === toggle || toggle.contains(event.target) || menu.contains(event.target)) {
        return;
      }

      closeProductPicker();
    };

    const keydown = (event) => {
      if (event.key === 'Escape') {
        closeProductPicker();
        toggle.focus();
      }
    };

    activePicker = { card, toggle, menu, close, outside, keydown };

    window.addEventListener('resize', close, true);
    window.addEventListener('scroll', close, true);
    document.addEventListener('pointerdown', outside, true);
    document.addEventListener('keydown', keydown, true);
  };

  const hydratePicker = async (card) => {
    const handle = card.dataset.productHandle || '';
    const sourceOptions = Array.from(
      card.querySelectorAll('[data-egifts-product-picker-option]')
    );

    if (!handle || !sourceOptions.length || card.dataset.egiftsPickerHydrated === 'true') {
      return;
    }

    card.dataset.egiftsPickerHydrated = 'loading';

    try {
      const response = await baseFetch(getProductJsonUrl(handle), {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error(`Product JSON HTTP ${response.status}`);
      }

      const product = await response.json();
      const variants = Array.isArray(product?.variants) ? product.variants : [];

      variants.forEach((variant) => {
        const sourceOption = sourceOptions.find(
          (option) => String(option.dataset.variantId || '') === String(variant.id)
        );

        if (!sourceOption) return;

        sourceOption.dataset.price = formatMoney(variant.price);
        sourceOption.dataset.previewKey = handleize(variant.title || sourceOption.dataset.label || '');

        const imageUrl = getVariantImage(variant, product);
        if (imageUrl) sourceOption.dataset.image = imageUrl;
      });

      card.dataset.egiftsPickerHydrated = 'true';
    } catch (error) {
      card.dataset.egiftsPickerHydrated = 'fallback';
      console.warn('E-gifts same design: picker używa danych awaryjnych dla', handle);
    }
  };

  const initCards = (root) => {
    root.querySelectorAll('[data-egifts-addon]').forEach((card) => {
      if (card.dataset.egiftsCardReady === 'true') return;
      card.dataset.egiftsCardReady = 'true';

      const toggle = card.querySelector('[data-egifts-product-picker-toggle]');
      const options = getSourceOptions(card);

      if (toggle && options.length) {
        const selected =
          options.find(
            (option) =>
              String(option.variantId) === String(card.dataset.selectedVariantId || '')
          ) || options[0];

        applyVariant(card, selected);
        hydratePicker(card);

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (activePicker?.toggle === toggle) {
            closeProductPicker();
          } else {
            openProductPicker(card, toggle);
          }
        });
      }

      const addButton = card.querySelector('[data-egifts-add]');

      if (addButton) {
        addButton.addEventListener('click', async (event) => {
          event.preventDefault();
          if (root.dataset.adding === 'true' || root.dataset.egiftsResolving === 'true') return;
          const selected = addButton.getAttribute('aria-pressed') !== 'true';
          setSelected(root, card, selected);
          if (!selected) return;

          root.dataset.egiftsResolving = 'true';
          addButton.disabled = true;
          try {
            await root._egiftsBaselinePromise;
            const cart = await fetchCart();
            const rememberedId = root._egiftsLastMainCustomizationId;
            const mainItem = rememberedId
              ? (cart.items || []).find((item) => isTeeinblueMainItem(item)
                && getCustomizationId(item) === rememberedId
                && Number(item.product_id) === Number(root.dataset.currentProductId))
              : findNewMainItem(root, cart);
            if (mainItem) {
              rememberMainItem(root, mainItem);
              await addSelectedAddons(root, mainItem);
            } else {
              root._egiftsLastMainCustomizationId = '';
            }
          } catch (error) {
            setSelected(root, card, false);
            setNote(root, root.dataset.cartError || 'Nie udało się dodać dodatku. Spróbuj ponownie.', 'error');
          } finally {
            delete root.dataset.egiftsResolving;
            addButton.disabled = false;
          }
        });
      }
    });
  };

  const getSelectedAddons = (root) => {
    return Array.from(root.querySelectorAll('[data-egifts-addon].is-selected'))
      .map((card) => ({
        card,
        family: card.dataset.family || '',
        productId: card.dataset.productId || '',
        variantId: card.dataset.selectedVariantId || '',
        previewKey: card.dataset.previewKey || ''
      }))
      .filter((item) => item.variantId);
  };

  const getProperties = (item) => {
    return item && typeof item.properties === 'object' && item.properties ? item.properties : {};
  };

  const getCustomizationId = (item) => String(getProperties(item)._customization_id || '');

  const isTeeinblueMainItem = (item) => {
    const properties = getProperties(item);
    const customizationId = properties._customization_id;
    const teeDesign = properties._tib_design_link_1 || properties._tib_design_link;
    const teeSku = properties._tib_fulfilled_sku;
    const isAddon = String(properties._egifts_same_design || '') === '1';

    return Boolean(customizationId && (teeDesign || teeSku) && !isAddon);
  };

  const fetchCart = async () => {
    const response = await baseFetch(cartJsonUrl(), {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });

    if (!response.ok) throw new Error(`Cart HTTP ${response.status}`);
    return response.json();
  };

  const rememberKnownCustomizations = async (root) => {
    try {
      const cart = await fetchCart();

      root._egiftsKnownCustomizations = new Set(
        (cart.items || [])
          .filter(isTeeinblueMainItem)
          .map(getCustomizationId)
          .filter(Boolean)
      );
    } catch (error) {
      root._egiftsKnownCustomizations = root._egiftsKnownCustomizations || new Set();
    }
  };

  const rememberMainItem = (root, mainItem) => {
    const customizationId = getCustomizationId(mainItem);
    root._egiftsLastMainCustomizationId = customizationId;
    root._egiftsKnownCustomizations = root._egiftsKnownCustomizations || new Set();
    if (customizationId) root._egiftsKnownCustomizations.add(customizationId);
    try {
      if (!window.localStorage.getItem(storageKey(customizationId))) saveArtworkForCart(customizationId);
    } catch (error) {}
  };

  const getCartComponent = () => {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  };

  const decorateCartNotification = (selected, artworkTemplate) => {
    clearNotificationDecoration();
    if (!selected.length || !artworkTemplate) return;

    const addon = selected[selected.length - 1];
    const notificationRoot = document.querySelector('cart-notification')
      || document.querySelector('#cart-notification');
    if (!notificationRoot) return;

    let observer = null;
    let stopped = false;
    const timers = [];

    clearNotificationDecoration = () => {
      stopped = true;
      observer?.disconnect();
      timers.forEach((timer) => window.clearTimeout(timer));
    };

    const apply = () => {
      if (stopped) return;
      if (!notificationRoot.isConnected) {
        clearNotificationDecoration();
        return;
      }

      observer?.disconnect();
      try {
        const notificationProduct = notificationRoot.querySelector('#cart-notification-product');
        const image = notificationProduct?.querySelector('img');
        const wrapper = image?.parentElement;
        if (!wrapper) return;

        const existing = wrapper.querySelector('.egifts-sd-notification-preview__artwork');
        if (existing?._egiftsArtworkTemplate === artworkTemplate) return;

        existing?.remove();
        wrapper.classList.add('egifts-sd-notification-preview');
        wrapper.dataset.family = addon.family || '';
        wrapper.dataset.previewKey = addon.previewKey || '';

        const artwork = document.createElement('span');
        artwork.className = 'egifts-sd-notification-preview__artwork';
        artwork._egiftsArtworkTemplate = artworkTemplate;
        artwork.append(artworkTemplate.cloneNode(true));
        wrapper.append(artwork);
      } finally {
        if (!stopped) observer?.observe(notificationRoot, { subtree: true, childList: true });
      }
    };

    observer = new MutationObserver(apply);
    apply();
    [90, 320, 900, 1400].forEach((delay) => timers.push(window.setTimeout(apply, delay)));
    timers.push(window.setTimeout(clearNotificationDecoration, 1800));
  };

  const addSelectedAddons = async (root, mainItem) => {
    const selected = getSelectedAddons(root);
    if (!selected.length) return;

    const liveSource = findArtwork();
    const notificationArtwork = liveSource ? makeClone(liveSource, true) : null;

    const mainProperties = getProperties(mainItem);
    const customizationId = String(mainProperties._customization_id || '');

    if (!customizationId || processedCustomizationIds.has(customizationId)) return;

    processedCustomizationIds.add(customizationId);
    rememberMainItem(root, mainItem);

    root.dataset.adding = 'true';
    setNote(root, 'Dodaję wybrane produkty do koszyka…');

    const designUrl = String(mainProperties._tib_design_link_1 || mainProperties._tib_design_link || '');
    const previewUrl = String(mainProperties._customization_image || '');
    const sourceProductTitle = String(root.dataset.currentProductTitle || '').trim();
    const checkoutPatternLabel = sourceProductTitle
      ? `Taki sam jak „${sourceProductTitle}”`
      : 'Taki sam jak na produkcie głównym';

    const items = selected.map(({ family, productId, variantId, previewKey }) => ({
      id: Number(variantId),
      quantity: 1,
      properties: {
        'Wzór': checkoutPatternLabel,
        _egifts_same_design: '1',
        _egifts_same_design_version: VERSION,
        _egifts_same_design_target: family,
        _egifts_same_design_group: customizationId,
        _egifts_parent_customization_id: customizationId,
        _egifts_target_product_id: String(productId),
        _egifts_target_variant_id: String(variantId),
        _egifts_preview_key: previewKey,
        _egifts_source_product_id: String(root.dataset.currentProductId || ''),
        _egifts_source_variant_id: String(mainItem.variant_id || mainItem.id || ''),
        _egifts_source_design_url: designUrl,
        _egifts_source_preview_url: previewUrl
      }
    }));

    const cart = getCartComponent();
    const sectionIds = new Set(['cart-icon-bubble', 'cart-live-region-text']);

    if (typeof cart?.getSectionsToRender === 'function') {
      cart.getSectionsToRender().forEach((section) => {
        if (section?.id && sectionIds.size < 5) sectionIds.add(section.id);
      });
    }

    try {
      const response = await baseFetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items,
          sections: Array.from(sectionIds).slice(0, 5),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || `HTTP ${response.status}`);
      }

      const data = await response.json();

      try {
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          const addedItem = Array.isArray(data.items) ? data.items[data.items.length - 1] : null;
          const notificationData = addedItem ? { ...data, ...addedItem, sections: data.sections } : data;
          cart.renderContents(notificationData);
          decorateCartNotification(selected, notificationArtwork);
        }
      } catch (renderError) {
        console.warn('E-gifts: odświeżenie widoku koszyka', renderError);
      }

      selected.forEach(({ card }) => setSelected(root, card, false));

      setNote(root, 'Dodano wybrane produkty do koszyka.', 'success');
      window.setTimeout(() => setNote(root), 2200);

      root._egiftsKnownCustomizations = root._egiftsKnownCustomizations || new Set();
      root._egiftsKnownCustomizations.add(customizationId);
    } catch (error) {
      processedCustomizationIds.delete(customizationId);
      selected.forEach(({ card }) => setSelected(root, card, false));
      setNote(root, 'Nie udało się dodać dodatku. Spróbuj ponownie.', 'error');
      console.error('E-gifts same design:', error);
    } finally {
      processedCustomizationIds.delete(customizationId);
      delete root.dataset.adding;
    }
  };

  const findNewMainItem = (root, cart) => {
    const currentProductId = Number(root.dataset.currentProductId || 0);
    const known = root._egiftsKnownCustomizations || new Set();

    return (
      (cart.items || []).find((item) => {
        if (!isTeeinblueMainItem(item)) return false;
        if (currentProductId && Number(item.product_id) !== currentProductId) return false;

        const customizationId = getCustomizationId(item);
        return customizationId && !known.has(customizationId) && !processedCustomizationIds.has(customizationId);
      }) || null
    );
  };

  const watchForMainAddition = (root) => {
    if (root.dataset.egiftsWatching === 'true') return;

    root.dataset.egiftsWatching = 'true';
    let attempts = 0;
    const maxAttempts = 32;

    const tick = async () => {
      await root._egiftsBaselinePromise;
      attempts += 1;

      try {
        const cart = await fetchCart();
        const mainItem = findNewMainItem(root, cart);

        if (mainItem) {
          const customizationId = getCustomizationId(mainItem);
          saveArtworkForCart(customizationId);
          rememberMainItem(root, mainItem);

          root._egiftsKnownCustomizations = root._egiftsKnownCustomizations || new Set();
          if (customizationId) root._egiftsKnownCustomizations.add(customizationId);

          delete root.dataset.egiftsWatching;

          if (getSelectedAddons(root).length) {
            await addSelectedAddons(root, mainItem);
          }
          return;
        }
      } catch (error) {}

      if (attempts >= maxAttempts) {
        delete root.dataset.egiftsWatching;
        return;
      }

      window.setTimeout(tick, 220);
    };

    window.setTimeout(tick, 160);
  };

  const initRoot = (root) => {
    if (!root || root.dataset.egiftsInitialized === 'true') return;

    root.dataset.egiftsInitialized = 'true';
    initCards(root);
    root._egiftsBaselinePromise = rememberKnownCustomizations(root);

    let source = null;
    let sourceObserver = null;
    let renderTimer = null;
    let refreshTimer = null;

    const scheduleRender = () => {
      window.clearTimeout(renderTimer);
      renderTimer = window.setTimeout(() => {
        if (source && document.documentElement.contains(source)) renderArtwork(root, source);
      }, 90);
    };

    const watchSource = (nextSource) => {
      if (sourceObserver) sourceObserver.disconnect();
      source = nextSource;
      sourceObserver = null;

      if (!source) {
        root.hidden = true;
        return;
      }

      sourceObserver = new MutationObserver(scheduleRender);
      sourceObserver.observe(source, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });

      renderArtwork(root, source);
      root.hidden = false;
    };

    const refreshSource = () => {
      const nextSource = findArtwork();

      if (nextSource !== source) {
        watchSource(nextSource);
      } else if (nextSource) {
        renderArtwork(root, nextSource);
        root.hidden = false;
      } else {
        root.hidden = true;
      }
    };

    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refreshSource, 80);
    };

    const pageObserver = new MutationObserver((mutations) => {
      const externalChange = mutations.some((mutation) => !root.contains(mutation.target));
      if (externalChange) scheduleRefresh();
    });

    pageObserver.observe(document.body, {
      subtree: true,
      childList: true
    });

    refreshSource();
    [300, 800, 1600, 3000].forEach((delay) => window.setTimeout(refreshSource, delay));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(TEE_ATC_SELECTOR);
      if (!button) return;

      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        watchForMainAddition(root);
      });
    },
    true
  );

  window.EgiftsSameDesignV84 = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

/*
  Teeinblue cross-sell variant bridge

  W natywnym popupie cross-sell Teeinblue pokazuje jednocześnie opcję
  "Dostępne produkty" (np. Damska Biała / Damska Czarna) oraz zależną,
  techniczną opcję "Rodzaj produktu" (Biały / Czarny). Przez moment może
  wtedy powstać nieistniejąca kombinacja wariantu, co daje cenę 0,00 zł
  i stan "Wyprzedane".

  Most działa wyłącznie wewnątrz popupu cross-sell, automatycznie wybiera
  zgodny kolor techniczny i ukrywa jego powielony wiersz. Nie ingeruje
  w standardowy formularz produktu ani w inne opcje (np. rozmiar).
*/
(() => {
  const GLOBAL_KEY = 'EgiftsTeeCrossSellVariantSyncV1';
  const VERSION = '1.0';
  const POPUP_SELECTOR = '.tee-cross-sell-product-popup';
  const VARIANTS_SELECTOR = '.tee-variants';
  const HIDDEN_CLASS = 'egifts-tee-cross-sell-technical-option';
  const STYLE_ID = 'egifts-tee-cross-sell-variant-sync-style';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].applyAll();
    return;
  }

  let scheduled = false;
  let observer = null;

  const normalize = (value = '') => {
    return String(value)
      .replace(/[Łł]/g, (character) => (character === 'Ł' ? 'L' : 'l'))
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  const getColorKey = (value = '') => {
    const text = normalize(value);

    if (/(^|\s)(czarny|czarna|czarne|black)(\s|$)/.test(text)) return 'black';
    if (/(^|\s)(bialy|biala|biale|white)(\s|$)/.test(text)) return 'white';

    return '';
  };

  const isBareColorName = (value = '') => {
    return [
      'czarny',
      'czarna',
      'czarne',
      'black',
      'bialy',
      'biala',
      'biale',
      'white'
    ].includes(normalize(value));
  };

  const getInputLabel = (input) => {
    const wrapper = input?.closest('.tee-radio');
    const label = wrapper?.querySelector('label.tee-radio-label');

    return (
      label?.getAttribute('title') ||
      label?.getAttribute('data-title') ||
      label?.textContent ||
      input?.value ||
      ''
    );
  };

  const getGroupData = (group) => {
    const heading = group.querySelector('.tee-option__title')?.textContent || '';
    const items = Array.from(group.querySelectorAll('input[type="radio"]')).map((input) => {
      const label = getInputLabel(input);

      return {
        input,
        label,
        colorKey: getColorKey(label)
      };
    });

    return {
      group,
      heading,
      normalizedHeading: normalize(heading),
      items
    };
  };

  const hasWhiteAndBlack = (data) => {
    const keys = new Set(data.items.map((item) => item.colorKey).filter(Boolean));
    return keys.has('white') && keys.has('black');
  };

  const analyzeVariantSelector = (variantSelector) => {
    const groups = Array.from(variantSelector.children)
      .filter((element) => element.classList.contains('tee-option'))
      .map(getGroupData)
      .filter((data) => data.items.length);

    if (groups.length < 2) return null;

    let technical = groups.find(
      (data) =>
        hasWhiteAndBlack(data) &&
        /(rodzaj produktu|product type)/.test(data.normalizedHeading)
    );

    if (!technical) {
      technical = groups.find(
        (data) =>
          hasWhiteAndBlack(data) &&
          data.items.every((item) => item.colorKey && isBareColorName(item.label))
      );
    }

    if (!technical) return null;

    let source = groups.find(
      (data) =>
        data !== technical &&
        hasWhiteAndBlack(data) &&
        /(dostepn(e|y).*produkt|available.*product)/.test(data.normalizedHeading)
    );

    if (!source) {
      source = groups.find(
        (data) =>
          data !== technical &&
          hasWhiteAndBlack(data) &&
          data.items.every((item) => item.colorKey) &&
          data.items.some((item) => !isBareColorName(item.label))
      );
    }

    if (!source) return null;

    const sourceKeys = new Set(source.items.map((item) => item.colorKey));
    const technicalKeys = new Set(technical.items.map((item) => item.colorKey));

    if (
      !sourceKeys.has('white') ||
      !sourceKeys.has('black') ||
      !technicalKeys.has('white') ||
      !technicalKeys.has('black')
    ) {
      return null;
    }

    return { variantSelector, source, technical };
  };

  const getPairs = (popup) => {
    return Array.from(popup.querySelectorAll(VARIANTS_SELECTOR))
      .map(analyzeVariantSelector)
      .filter(Boolean);
  };

  const hideTechnicalGroup = (pair) => {
    pair.technical.group.classList.add(HIDDEN_CLASS);
    pair.technical.group.setAttribute('aria-hidden', 'true');
  };

  const syncPairToColor = (pair, colorKey) => {
    if (!pair || !colorKey) return false;

    hideTechnicalGroup(pair);

    const target = pair.technical.items.find((item) => item.colorKey === colorKey)?.input;
    if (!target) return false;
    if (target.checked) return true;

    /*
      Teeinblue oznacza niedopasowaną opcję klasą wizualną. W aktualnej
      wersji aplikacji radio nie ma atrybutu disabled, ale poniższa osłona
      zachowuje działanie także po ewentualnej zmianie SDK.
    */
    if (target.disabled) target.disabled = false;

    target.click();
    return target.checked;
  };

  const getCheckedSourceColor = (pair) => {
    const checked = pair.source.items.find((item) => item.input.checked);
    return checked?.colorKey || '';
  };

  const applyPopup = (popup) => {
    getPairs(popup).forEach((pair) => {
      hideTechnicalGroup(pair);

      const colorKey = getCheckedSourceColor(pair);
      if (colorKey) syncPairToColor(pair, colorKey);
    });
  };

  const applyAll = () => {
    document.querySelectorAll(POPUP_SELECTOR).forEach(applyPopup);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  };

  const retrySync = (popup, expectedColor) => {
    [0, 16, 50, 120, 250].forEach((delay) => {
      window.setTimeout(() => {
        if (!document.documentElement.contains(popup)) return;

        getPairs(popup).forEach((pair) => {
          const currentColor = getCheckedSourceColor(pair);
          if (currentColor === expectedColor) syncPairToColor(pair, expectedColor);
        });
      }, delay);
    });
  };

  const handleRadioInteraction = (event) => {
    const input = event.target?.closest?.(
      `${POPUP_SELECTOR} ${VARIANTS_SELECTOR} .tee-option input[type="radio"]`
    );

    if (!input) return;

    const popup = input.closest(POPUP_SELECTOR);
    const variantSelector = input.closest(VARIANTS_SELECTOR);
    const pair = analyzeVariantSelector(variantSelector);

    if (!popup || !pair || !pair.source.group.contains(input)) return;

    const expectedColor = getColorKey(getInputLabel(input));
    if (!expectedColor) return;

    /*
      Klik technicznego radia odbywa się synchronicznie, zanim Vue wykona
      następne renderowanie. Dzięki temu Teeinblue od razu otrzymuje pełną,
      prawidłową kombinację i nie powinien pokazać 0,00 zł / Wyprzedane.
    */
    syncPairToColor(pair, expectedColor);
    retrySync(popup, expectedColor);
  };

  const installStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      ${POPUP_SELECTOR} .${HIDDEN_CLASS} {
        display: none !important;
      }
    `;

    document.head.append(style);
  };

  const init = () => {
    installStyles();
    applyAll();

    if (!observer && document.documentElement) {
      observer = new MutationObserver(schedule);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    [100, 300, 700, 1400].forEach((delay) => window.setTimeout(schedule, delay));
  };

  document.addEventListener('click', handleRadioInteraction);
  document.addEventListener('change', handleRadioInteraction);
  document.addEventListener('shopify:section:load', schedule);

  window[GLOBAL_KEY] = {
    version: VERSION,
    applyAll: schedule
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();